module.exports = __webpack_public_path__ + "static/media/arrow-is-wrong.582283a1.mp3";